export const SOLUTIONS = [
  // A
  'anden', 'armen', 'aften', 'anker', 'angst',
  // B
  'banen', 'broen', 'blæse', 'bilen', 'brude',
  // C
  'cider', 'cykle', 'creme', 'civil', 'citat',
  // D
  'drage', 'dalen', 'døren', 'dagen', 'dyrke',
  // E
  'elske', 'egnen', 'enden', 'enorm',
  // F
  'farve', 'flyve', 'frisk', 'fryse', 'feber',
  // G
  'grine', 'gribe', 'gulve', 'glæde', 'gaven',
  // H
  'huset', 'højde', 'håbet', 'hæfte', 'hilse',
  // I
  'isene', 'ildne', 'input', 'intro',
  // J
  'joken', 'jorde', 'jager', 'jolle', 'julen', 'jyske', 'jokes',
  // K
  'krone', 'kaste', 'kurve', 'kugle', 'kjole',
  // L
  'læser', 'lysne', 'løbet', 'lande', 'loven',
  // M
  'magte', 'mødet', 'moden', 'maler', 'månen',
  // N
  'næsen', 'navne', 'nogen', 'navle', 'nytte',
  // O
  'orden', 'offer', 'onkel', 'overe', 'ombud',
  // P
  'prøve', 'penge', 'puder', 'pynte', 'plads',
  // Q
  'qatar',
  // R
  'regne', 'rette', 'rodeo', 'runde', 'rulle',
  // S
  'skriv', 'søger', 'smage', 'skabe', 'sløve',
  // T
  'træne', 'talen', 'toget', 'tunge', 'trist',
  // U
  'under', 'udnyt', 'udvej', 'urene', 'uldne', 'udgav', 'udkig',
  // V
  'vende', 'vilde', 'vokse', 'værre', 'vores',
  // W
  'wiren', 'wirer',
  // Y
  'yngel', 'yndet', 'yndig', 'yders', 'yppig',
  // Z
  'zebra', 'zebus', 'zinks', 'zobel', 'zombi', 'zonen', 'zoner', 'zooen', 'zooer',
  // Æ
  'æbler', 'ægget', 'ældre', 'ædelt',
  // Ø
  'ønske', 'ørken', 'ørene', 'ørred', 'øvede',
  // Å
  'åbner', 'årene', 'åndes', 'ånden', 'åbent'
];

// Funktion til at få et tilfældigt løsningsord
export const getRandomSolution = (): string => {
  const randomIndex = Math.floor(Math.random() * SOLUTIONS.length);
  return SOLUTIONS[randomIndex];
};
